/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { InternationalAddressData } from '@flease/core-domain';
import type { Either } from '@flease/types';
import { Energy } from '@flease/core-domain';
import type { AddressData } from '@flease/core-domain';
import type { Modify } from '@flease/types';
import type { RecursiveReadonly } from '@flease/types';
import type { Optional } from '@flease/types';
import type { InspectionData } from '@flease/inspection-types';

export type { InternationalAddressData } from '@flease/core-domain';
export type { Either } from '@flease/types';
export { Energy } from '@flease/core-domain';
export type { AddressData } from '@flease/core-domain';
export type { Modify } from '@flease/types';
export type { RecursiveReadonly } from '@flease/types';
export type { Optional } from '@flease/types';
export type { InspectionData } from '@flease/inspection-types';
export type QueryFilters = Record<string, string | number>;
export type Sort = string[];
export type PageSize = number;
export type PageIndex = number;
export type UserSignInStatus = 'CREATED' | 'FORCED_CHANGE_PASSWORD' | 'NOT_EXISTS';
export interface TryResendingInvitationEvent {
  email: string;
}
export interface CompanyBillingInformationDTO {
  name: string;
  siret?: string;
  electronicBillingAddress?: string;
  address: InternationalAddressDTO;
  mandateStatus?: string;
  paymentMethod?: string;
  mandateConfiguration?: MandateConfigurationData;
  /** Faux quand le dashboard n'a pas répondu : le panneau sert alors la moitié locale, sans édition. */
  dashboardReachable: boolean;
}
export type InternationalAddressDTO = InternationalAddressData;
export interface MandateConfigurationData {
  paymentMethodRequestId: string;
  validationKey: string;
}
export type CompanyBillingInformationControllerGetClientIdPath = string;
export type CompanyBillingInformationControllerGetCompanyIdPath = string;
export type CompanyBillingInformationControllerUpdateClientIdPath = string;
export type CompanyBillingInformationControllerUpdateCompanyIdPath = string;
export interface EditableBillingInformationData {
  electronicBillingAddress?: string;
  address: InternationalAddressData;
}
export type MandateConfigurationLinkResult = Either<{ error: string }, { link: string }>;
export type MandateConfigurationControllerGetMandateConfigurationLinkPaymentMethodIdQuery = string;
export type MandateConfigurationControllerGetMandateConfigurationLinkKeyQuery = string;
export type CarConditionReportControllerListAllResponse = ClientConditionReportDTO[];
export type ClientConditionReportDTO = {
  contractId: string;
  rentalPeriodId: string;
  licensePlate?: string;
  modelName: string;
  reports: ConditionReportPicturesData[];
  conditionReports: ConditionReportDTO[];
};
export interface ConditionReportPicturesData {
  conditionReportId: string;
  vehiclePhotos: ConditionReportPicture[];
  windshieldPhotos: ConditionReportPicture[];
  damagePhotos: DamagePhotoGroup[];
}
export type ConditionReportPicture = {
  key: string;
  url: string;
  size?: number;
};
export interface DamagePhotoGroup {
  damageId: string;
  photos: ConditionReportPicture[];
}
export type ConditionReportDTO = {
  id: string;
  clientId: string;
  contractId: string;
  rentalPeriodId: string;
  driverId?: string;
  status: ConditionReportStatus;
  createdAt: string;
  lastReportDate?: string;
  retakeRequest?: RetakeInfo;
  retakenPhotos?: RetakeInfo;
  isClean?: boolean;
  mileage?: number;
  hasMileageDiscrepancy: boolean;
  hasWindshieldImpact?: boolean;
  windshieldPhotoCount?: number;
  damages?: DamageEntry[];
};
export type ConditionReportStatus = 'pending' | 'completed';
export type RetakeInfo = { conditionReportId: string; photoIndexes: number[] };
export interface DamageEntry {
  id: string;
  location: DamageLocation;
  photoCount: number;
}
export type DamageLocation = (typeof DAMAGE_LOCATIONS)[number];
export const DAMAGE_LOCATIONS = [
  'avant',
  'arrière',
  'latéral gauche',
  'latéral droit',
  'intérieur',
  'autre',
] as const;
export type CarConditionReportControllerListAllClientIdPath = string;
export type CarConditionReportControllerListClientIdPath = string;
export type CarConditionReportControllerListContractIdPath = string;
export type CarConditionReportControllerListRentalPeriodIdPath = string;
export type CarConditionReportControllerGetUploadUrlResponse = { uploadUrl: string; key: string };
export type CarConditionReportControllerGetUploadUrlClientIdPath = string;
export type CarConditionReportControllerGetUploadUrlRentalPeriodIdPath = string;
export type CarConditionReportControllerGetUploadUrlReportTimestampPath = string;
export type CarConditionReportControllerGetUploadUrlPhotoIndexPath = string;
export type CarConditionReportControllerGetTempUploadUrlResponse = { uploadUrl: string; key: string };
export type CarConditionReportControllerGetTempUploadUrlClientIdPath = string;
export type TempUploadType = 'photo' | 'windshield' | 'damage';
export type CarConditionReportControllerGetTempUploadUrlRentalPeriodIdPath = string;
export type CarConditionReportControllerGetTempUploadUrlReportTimestampPath = string;
export type CarConditionReportControllerGetTempUploadUrlPhotoIndexPath = string;
export type CarConditionReportControllerGetTempUploadUrlDamageIdQuery = string;
export type CarConditionReportControllerCheckQualityResponse = { qualityOk: boolean };
export type CarConditionReportControllerCheckQualityClientIdPath = string;
export type CarConditionReportControllerCheckQualityRentalPeriodIdPath = string;
export type CarConditionReportControllerCheckQualityReportTimestampPath = string;
export type CarConditionReportControllerCheckQualityPhotoIndexPath = string;
export type CarConditionReportControllerValidateClientIdPath = string;
export type CarConditionReportControllerValidateContractIdPath = string;
export type CarConditionReportControllerValidateRentalPeriodIdPath = string;
export type CarConditionReportControllerValidateReportTimestampPath = string;
export type CarConditionReportControllerValidateBody = {
      isClean: boolean;
      mileage: number;
      hasWindshieldImpact: boolean;
      windshieldPhotoCount?: number;
      damages?: DamageEntry[];
    };
export type CarConditionReportControllerRequestRetakeClientIdPath = string;
export type CarConditionReportControllerRequestRetakeContractIdPath = string;
export type CarConditionReportControllerRequestRetakeRentalPeriodIdPath = string;
export type CarConditionReportControllerRequestRetakeConditionReportIdPath = string;
export type CarConditionReportControllerRequestRetakeBody = { photoIndexes: number[] };
export type CarConditionReportControllerValidateRetakeClientIdPath = string;
export type CarConditionReportControllerValidateRetakeContractIdPath = string;
export type CarConditionReportControllerValidateRetakeRentalPeriodIdPath = string;
export type CarConditionReportControllerValidateRetakeConditionReportIdPath = string;
export type CarConditionReportControllerValidateRetakeBody = { photoIndexes: number[] };
export type CarConditionReportControllerAcknowledgeRetakenClientIdPath = string;
export type CarConditionReportControllerAcknowledgeRetakenContractIdPath = string;
export type CarConditionReportControllerAcknowledgeRetakenRentalPeriodIdPath = string;
export type CarConditionReportControllerToggleSharingClientIdPath = string;
export type CarConditionReportControllerToggleSharingBody = { enabled: boolean };
export type CarConditionReportControllerDeleteTempPhotoClientIdPath = string;
export type DeletablePhotoType = 'windshield' | 'damage';
export type CarConditionReportControllerDeleteTempPhotoRentalPeriodIdPath = string;
export type CarConditionReportControllerDeleteTempPhotoReportTimestampPath = string;
export type CarConditionReportControllerDeleteTempPhotoPhotoIndexPath = string;
export type CarConditionReportControllerDeleteTempPhotoDamageIdQuery = string;
export type CarConditionReportControllerDeleteTempDamageClientIdPath = string;
export type CarConditionReportControllerDeleteTempDamageRentalPeriodIdPath = string;
export type CarConditionReportControllerDeleteTempDamageReportTimestampPath = string;
export type CarConditionReportControllerDeleteTempDamageDamageIdPath = string;
export type CarDocumentControllerExistsResponse = boolean;
export type CarDocumentControllerExistsCarIdPath = string;
export type CarDocumentType = 'immatriculation' | 'fiv' | 'safety-inspection';
export type DashboardCompaniesAndSalesmanDTO = DashboardCompaniesAndSalesmanData;
export interface DashboardCompaniesAndSalesmanData {
  companies: DashboardCompanyData[];
  salesman: string;
}
export interface DashboardCompanyData {
  name: string;
  id: string;
}
export type DashboardControllerListClientIdPath = string;
export type DashboardControllerListMediumTermCategoriesResponse = DashboardMediumTermCategoryDTO[];
export type DashboardMediumTermCategoryDTO = DashboardMediumTermCategoryData;
export interface DashboardMediumTermCategoryData {
  id: string;
  name: string;
  models: string[];
}
export type DeliveredCarControllerListResponse = DeliveredCar[];
export type DeliveredCar = CommonCarInformation &
  CommonDeliveredInformation & {
    status: CarStatus.DELIVERED;
    rentalPeriod: DeliveredCarRentalPeriod;
    tracking: Tracking;
    drivingPeriods: DrivingPeriodData[];
    customFields?: CustomFieldValues;
  };
export interface CommonCarInformation {
  contract: CarContract;
  model: CarModel;
  client: Client;
  insurance: {
    isInsuranceCertificateRequired?: boolean;
    isInsuranceCertificatePendingApproval?: boolean;
  };
}
export interface CarContract extends ContractDefinition {
  id: string;
  amendments: Amendment[];
  order: Order;
  nonBinding: boolean;
}
export interface Amendment extends ContractDefinition {
  id: string;
  signatureDate: string;
}
export interface ContractDefinition {
  duration: number;
  price: number;
  kilometrage: number;
  options: Option[];
  insurance?: number;
  geolocation?: number;
  ecoDriving?: number;
  midtermRenewal?: boolean;
}
export interface Option {
  price: number;
  name: string;
}
export interface Order extends ContractDefinition {
  id: string;
  signatureDate: string;
  midtermRenewal: boolean;
}
export interface CarModel {
  configuration: {
    carbonEmissionRate: number;
    fiscalPower: number;
    gearbox: Gearbox;
    enginePower: number;
    motorization: string;
    energy: Energy;
    fuelConsumptionRate?: number;
    electricConsumptionRate?: number;
  };
  name: string;
  finish: { name: string; id: string };
  id: string;
  brand: string;
  isUtility: boolean;
}
export enum Gearbox {
  AUTOMATIC = 'Automatic',
  MANUAL = 'Manual',
}
export interface Client {
  id: string;
  name: string;
  company: string;
  companyId: string;
}
export type CommonDeliveredInformation = {
  id: string;
  vin: string;
  buyingPrice: number;
  firstRentalPeriod?: FirstRentalPeriod;
  insuranceExpirationDate?: string;
  reportId?: string;
  verifleaseId?: string;
  actualCarbonEmissionRate?: number;
  temporaryLicensePlate?: string;
  licensePlate?: string;
  hasTemporaryAirSticker?: boolean;
  hasAskedSafetyInspection?: boolean;
  hasReviewableSafetyInspection?: boolean;
};
export interface FirstRentalPeriod {
  id: string;
  kilometrage: number;
  start: string;
}
export enum CarStatus {
  TO_DELIVER = 'TO_DELIVER',
  DELIVERED = 'DELIVERED',
  RESTITUTED = 'RESTITUTED',
}
export interface DeliveredCarRentalPeriod extends ToDeliverRentalPeriod {
  deliveryKilometrage: number;
  deliveryDate: string;
  isRestitutionContactRequired?: boolean;
  restitutionContact?: DeliveryContactData;
  restitutionAddress?: AddressData;
  restitutionPrice?: number;
  restitutionDiscount?: number;
  restitutionSlot?: TimeSlotData;
  restitutionDate?: never;
  restitutionKilometrage?: never;
  isDeliveryContactInformationRequired: boolean;
  deliveryPrice: number;
  deliveryDiscount: number;
  deliveryContact: DeliveryContactData;
  deliveryAddress: AddressData;
  deliverySlot: TimeSlotData;
  floorMatsOrdered?: boolean;
}
export interface DeliveryContactData {
  name: string;
  phone: string;
}
export type TimeSlotData = {
  start: string;
  end: string;
};
export interface ToDeliverRentalPeriod {
  id: string;
  isDeliveryContactInformationRequired?: boolean;
  deliveryPrice?: number;
  deliveryDiscount?: number;
  deliveryContact?: DeliveryContactData;
  deliveryAddress?: AddressData;
  deliverySlot?: TimeSlotData;
  floorMatsOrdered?: boolean;
}
export interface Tracking {
  kilometrage: number;
  currentKilometrage?: number;
  boxNumber?: string;
  type: TrackingType;
  maintenance: MaintenanceTracking;
  updateTime?: string;
}
export enum TrackingType {
  SOFLEET = 'SOFLEET',
  MUNIC = 'MUNIC',
  GEOCLIC = 'GEOCLIC',
  LINK_BY_CAR = 'LINK_BY_CAR',
  NONE = 'NONE',
}
export type MaintenanceTracking = {
  daysToNext?: number;
  daysBetween?: number;
  distanceBetween?: number;
  distanceToNext?: number;
};
export type DrivingPeriodData = {
  id: string;
  startDate: string;
  endDate?: string;
  driverId: string;
};
export type CustomFieldValues = { [key: string]: string | number | boolean };
export type DeliveredCarControllerListClientIdPath = string;
export type RestitutedCarControllerListResponse = RestitutedCar[];
export type RestitutedCar = CommonDeliveredInformation &
  CommonCarInformation & {
    status: CarStatus.RESTITUTED;
    rentalPeriod: RestitutedRentalPeriod;
    drivingPeriods: DrivingPeriodData[];
  };
export type RestitutedRentalPeriod = Modify<
  DeliveredCarRentalPeriod,
  {
    restitutionDate: string;
    restitutionKilometrage: number;
  }
>;
export type RestitutedCarControllerListClientIdPath = string;
export type CustomerNeedControllerCreateClientIdPath = string;
export type NewCustomerNeedData = {
  categoryElements: CategoryElementData[];
  commentary?: string;
  clientId: string;
  companyId: string;
  createdBy: string;
  salesmanEmail: string;
};
export type CategoryElementData = {
  type: CustomerNeedTypeData;
  numberOfVehicles: number;
  category: string;
};
export type CustomerNeedTypeData = `${CustomerNeedType}`;
export enum CustomerNeedType {
  LMD = 'LMD',
  LLD = 'LLD',
}
export type CustomerNeedControllerCreateBody = Omit<NewCustomerNeedData, 'clientId'>;
export type CustomFieldsControllerUpdateClientIdPath = string;
export type CustomFieldsControllerUpdateContractIdPath = string;
export type CustomFieldsControllerUpdateRentalPeriodIdPath = string;
export type SettingsDTO = Required<SettingsData>;
export type SettingsData = RecursiveReadonly<{
  clientId: string;
  carFieldSettings?: CarFieldSettingsData;
  ignoredEcoDrivingMetricsSettings?: EcoDrivingMetricType[];
  doesCompanyHandleFuelExpenses?: boolean;
  taxPercentAND?: number;
  companies?: CompanyData[];
  conditionReportPeriodInMonths?: number;
  shareConditionReportsWithDashboard?: boolean;
  conditionReportFeatureEnabled?: boolean;
}>;
export type CarFieldSettingsData = RecursiveReadonly<{
  fields: CustomFieldsData;
  activated: boolean;
}>;
export type CustomFieldsData = (CustomCarFieldData | ListCarFieldData)[];
export type CustomCarFieldData = {
  name: string;
  type: Exclude<CustomCarFieldType, CustomCarFieldType.List>;
};
export enum CustomCarFieldType {
  Text = 'Text',
  LongText = 'LongText',
  Number = 'Number',
  Boolean = 'Boolean',
  Price = 'Price',
  List = 'List',
}
export type ListCarFieldData = { values: string[]; name: string; type: CustomCarFieldType.List };
export type EcoDrivingMetricType =
  | 'constantSpeed'
  | 'idleDuration'
  | 'riskManagement'
  | 'brakingManagement'
  | 'rpmAccelerationMean'
  | 'carbonEmissionMeanGap'
  | 'tripDuration'
  | 'restDuration'
  | 'tripLength'
  | 'nightDrive';
export interface CompanyData {
  id: string;
  name: string;
  address: StoredCompanyAddressData;
  electronicBillingAddress?: string;
  negotiatedPricing?: NegotiatedPricingData;
}
export interface StoredCompanyAddressData extends AddressData {
  country?: string;
}
export interface NegotiatedPricingData {
  deliveryPrices: DeliveryPricesData;
  floorMats: number;
}
export interface DeliveryPricesData {
  lyonOrPeriphery: number;
  farFromLyon: number;
  other: number;
}
export type SettingsControllerGetClientIdPath = string;
export type SettingsControllerUpdateClientIdPath = string;
export type StatisticsControllerGetPositionHistoryResponse = MergedJourney[];
export type MergedJourney = {
  firstJourneyId: string;
  legs: JourneyData[];
};
export type JourneyData = {
  id: string;
  positions: { latlng: MapCoords; timestamp: string }[];
};
export type MapCoords = [number, number];
export type StatisticsControllerGetPositionHistoryClientIdPath = string;
export type StatisticsControllerGetPositionHistoryContractIdPath = string;
export type StatisticsControllerGetPositionHistoryRentalPeriodIdPath = string;
export type StatisticsControllerGetPositionHistoryCarIdPath = string;
export type StatisticsControllerGetPositionHistoryStartQuery = string;
export type StatisticsControllerGetPositionHistoryEndQuery = string;
export type KilometrageDifferenceGraphData = {
  data: {
    day: { [driver: string]: { [day: string]: { traveled: number } } };
    month: { [driver: string]: { [month: string]: { traveled: number } } };
  };
  categories: {
    day: string[];
    month: string[];
  };
};
export type StatisticsControllerGetKilometrageHistoryClientIdPath = string;
export type StatisticsControllerGetKilometrageHistoryContractIdPath = string;
export type StatisticsControllerGetKilometrageHistoryRentalPeriodIdPath = string;
export type StatisticsControllerGetKilometrageHistoryCarIdPath = string;
export type StatisticsControllerGetKilometrageHistoryStartQuery = string;
export type StatisticsControllerGetKilometrageHistoryEndQuery = string;
export type StatisticsControllerGetKilometrageHistoryPerDriverQuery = '0' | '1';
export type TripStats = TripStatsGraphData & { detailed: boolean };
export type TripStatsGraphData = {
  data: {
    day: { [driver: string]: { [day: string]: AggregatedTripsData } };
    month: { [driver: string]: { [month: string]: AggregatedTripsData } };
  };
  categories: {
    day: string[];
    month: string[];
  };
};
export type AggregatedTripsData = {
  tripDrivenFuel: number;
  tripUrbanConsumption: number;
  tripMixteConsumption: number;
  tripMotorwayConsumption: number;
  tripUrbanDistance: number;
  tripMixteDistance: number;
  tripMotorwayDistance: number;
  tripCarbonEmission: number;
  tripAccelDistance: number;
  tripConstantSpeedDistance: number;
  tripHarshAccelCount: number;
  tripHarshBrakeCount: number;
  tripIdleFuel: number;
  tripIdleCount: number;
  tripIdleDuration: number;
  tripExcessRpmCount: number;
  tripExcessRpmDuration: number;
  tripAvgRpm: number;
  tripAvgAccelerationRpm: number;
  tripUrbanDuration: number;
  tripMixteDuration: number;
  tripMotorwayDuration: number;
  tripDistance: number;
  tripDuration: number;
};
export type StatisticsControllerGetTripStatsHistoryClientIdPath = string;
export type StatisticsControllerGetTripStatsHistoryContractIdPath = string;
export type StatisticsControllerGetTripStatsHistoryRentalPeriodIdPath = string;
export type StatisticsControllerGetTripStatsHistoryCarIdPath = string;
export type StatisticsControllerGetTripStatsHistoryStartQuery = string;
export type StatisticsControllerGetTripStatsHistoryEndQuery = string;
export type StatisticsControllerGetTripStatsHistoryPerDriverQuery = '0' | '1';
export type EcoDrivingGraphDTO = {
  [driver: string]: { eco: EcoDrivingMetricDTO[]; security: EcoDrivingMetricDTO[] };
};
export type EcoDrivingMetricDTO = {
  score: number;
  explanation: string;
  explanationKey: string;
  value: number;
  type: EcoDrivingMetricType;
  title: string;
  subtitle: string;
  unit: EcoDrivingMetricUnit;
};
export type EcoDrivingMetricUnit =
  | '%'
  | 's'
  | 'risque/100km'
  | 'freinage/100km'
  | 'tr/min'
  | 'g/km'
  | 'min';
export type StatisticsControllerGetEcoDrivingMetricsClientIdPath = string;
export type StatisticsControllerGetEcoDrivingMetricsContractIdPath = string;
export type StatisticsControllerGetEcoDrivingMetricsRentalPeriodIdPath = string;
export type StatisticsControllerGetEcoDrivingMetricsCarIdPath = string;
export type StatisticsControllerGetEcoDrivingMetricsStartQuery = string;
export type StatisticsControllerGetEcoDrivingMetricsEndQuery = string;
export type StatisticsControllerGetEcoDrivingMetricsPerDriverQuery = '0' | '1';
export type FoundPositionDTO = {
  latlng: [number, number];
  timestamp: string;
};
export type StatisticsControllerFindLastPositionResponse = Optional<FoundPositionDTO>;
export type StatisticsControllerFindLastPositionClientIdPath = string;
export type StatisticsControllerFindLastPositionContractIdPath = string;
export type StatisticsControllerFindLastPositionRentalPeriodIdPath = string;
export type StatisticsControllerFindLastPositionCarIdPath = string;
export type CarToDeliverDTO = CarToDeliverData;
export interface CarToDeliverData {
  carModel?: CarModelDescriptionData;
  category?: string;
  clientId: string;
  contractId: string;
  rentalPeriodId: string;
  isDeliveryContactInformationRequired?: boolean;
  deliveryPrice?: number;
  deliveryDiscount?: number;
  deliveryContact?: DeliveryContactData;
  deliveryAddress?: AddressData;
  deliverySlot?: TimeSlotData;
  floorMatsOrdered?: boolean;
  plannedDriver?: string;
}
export interface CarModelDescriptionData {
  id: string;
  brand: string;
  name: string;
  isUtility: boolean;
  configuration: {
    carbonEmissionRate: number;
    enginePower: number;
    fiscalPower: number;
    motorization: string;
    energy: Energy;
    gearbox: Gearbox;
    electricConsumptionRate?: number;
    fuelConsumptionRate?: number;
  };
  finish: {
    id: string;
    name: string;
  };
}
export type CarToDeliverControllerAddDeliveryContactInformationClientIdPath = string;
export type CarToDeliverControllerAddDeliveryContactInformationContractIdPath = string;
export type CarToDeliverControllerAddDeliveryContactInformationRentalPeriodIdPath = string;
export interface AddDeliveryContactEvent {
  contact: DeliveryContactData;
  address: AddressData;
  floorMatsOrdered: boolean;
}
export type CarToDeliverControllerUpdateDriverClientIdPath = string;
export type CarToDeliverControllerUpdateDriverContractIdPath = string;
export type CarToDeliverControllerUpdateDriverRentalPeriodIdPath = string;
export type CarToDeliverControllerUpdateDriverBody = { driverId: string };
export type DriverControllerListDriversResponse = DriverWithAppInstallationDTO[];
export type DriverWithAppInstallationDTO = DriverDTO & { hasInstalledApp: boolean };
export type DriverDTO = Modify<DriverData, { onDuty: boolean }>;
export type DriverData = {
  id: string;
  firstname: string;
  lastname: string;
  clientId: string;
  company?: string;
  currentCarInformation?: CarInformationData;
  sub?: string;
  email?: string;
  onDuty?: boolean;
  lastMobileLoginAt?: string;
};
export type CarInformationData = RecursiveReadonly<{
  contractId: string;
  rentalPeriodId: string;
  carModel: CarModelDescriptionData;
}>;
export type DriverControllerListDriversClientIdPath = string;
export type DriverControllerCreateClientIdPath = string;
export type CreateDriverRequest = DriverInitData;
export type DriverInitData = {
  firstname: string;
  lastname: string;
  company?: string;
  clientId: string;
  email?: string;
};
export type DriverControllerCreateBody = Omit<CreateDriverRequest, 'clientId'>;
export type DriverControllerUpdateClientIdPath = string;
export type DriverControllerUpdateDriverIdPath = string;
export type UpdateDriverRequest = DriverInitData;
export type DriverControllerUpdateBody = Omit<UpdateDriverRequest, 'clientId'>;
export type DriverControllerDeleteClientIdPath = string;
export type DriverControllerDeleteDriverIdPath = string;
export type DriverControllerGetLoggedDriverResponse = Optional<DriverDTO>;
export type DriverControllerGetLoggedDriverClientIdPath = string;
export type DriverControllerUpdateLastMobileLoginClientIdPath = string;
export type DriverControllerToggleOnDutyClientIdPath = string;
export type DroveCarDTO = Omit<
  DroveCarData,
  'drivingPeriods' | 'actualCarbonEmissionRate' | 'boxNumber'
> & {
  drivingPeriods: DrivingPeriodDTO[];
};
export interface DroveCarData {
  carModel: CarModelDescriptionData;
  clientId: string;
  contractId: string;
  rentalPeriodId: string;
  drivingPeriods?: DrivingPeriodData[];
  isRestitutionContactRequired?: boolean;
  restitutionContact?: DeliveryContactData;
  restitutionAddress?: AddressData;
  restitutionPrice?: number;
  restitutionDiscount?: number;
  restitutionSlot?: TimeSlotData;
  isDeliveryContactInformationRequired?: boolean;
  deliveryPrice?: number;
  deliveryDiscount?: number;
  deliveryContact?: DeliveryContactData;
  deliveryAddress?: AddressData;
  deliverySlot?: TimeSlotData;
  actualCarbonEmissionRate?: number;
  restitutionDate?: string;
  restitutionKilometrage?: number;
  reportId?: string;
  verifleaseId?: string;
  boxNumber?: string;
  hasTemporaryAirSticker?: boolean;
  hasGeolocation?: boolean;
}
export type DrivingPeriodDTO = DrivingPeriodData;
export type DroveCarControllerUpdateDrivingPeriodsClientIdPath = string;
export type DroveCarControllerUpdateDrivingPeriodsContractIdPath = string;
export type DroveCarControllerUpdateDrivingPeriodsRentalPeriodIdPath = string;
export type DroveCarControllerUpdateDrivingPeriodsBody = (DrivingPeriodData | DrivingPeriodInitData)[];
export type DrivingPeriodInitData = Omit<DrivingPeriodData, 'id'>;
export type DroveCarControllerFillRestitutionContactClientIdPath = string;
export type DroveCarControllerFillRestitutionContactContractIdPath = string;
export type DroveCarControllerFillRestitutionContactRentalPeriodIdPath = string;
export interface AddRestitutionContactEvent extends RestitutionContactInformation {
  wishedRestitutionDate: string;
}
export interface RestitutionContactInformation {
  contact: DeliveryContactData;
  address: AddressData;
}
export type DroveCarControllerToggleCarOnDutyResponse = { onDuty: boolean };
export type DroveCarControllerToggleCarOnDutyClientIdPath = string;
export type DroveCarControllerToggleCarOnDutyContractIdPath = string;
export type DroveCarControllerToggleCarOnDutyRentalPeriodIdPath = string;
export type DroveCarControllerGetCarOnDutyResponse = { onDuty: boolean };
export type DroveCarControllerGetCarOnDutyClientIdPath = string;
export type DroveCarControllerGetCarOnDutyContractIdPath = string;
export type DroveCarControllerGetCarOnDutyRentalPeriodIdPath = string;
export type ExportControllerGetFleetExportResponse = string;
export type ExportControllerGetFleetExportClientIdPath = string;
export type ExportControllerGetTaxesExportResponse = string;
export type ExportControllerGetTaxesExportClientIdPath = string;
export type ExportControllerGetTaxesExportYearQuery = 'current' | 'minus1' | 'minus2' | 'minus3';
export type ExportControllerGetTaxesExportProportionQuery = 'annual' | 'perDrivingPeriod';
export type ExportControllerGetTaxesExportFuelExpensesQuery = 'company' | 'driver';
export type ExportControllerGetLeasingCertificateResponse = string;
export type ExportControllerGetLeasingCertificateClientIdPath = string;
export type ExportControllerGetLeasingCertificateContractIdPath = string;
export type ExportControllerGetLeasingCertificateRentalPeriodIdPath = string;
export type InvoiceExportRequestDTO = InvoiceExportRequestBase &
  (
    | { status: 'PENDING' }
    | { status: 'READY'; filePath: string }
    | { status: 'ERROR'; errorMessage: string }
  );
export type InvoiceExportRequestBase = {
  clientId: string;
  companyId: string;
  startDate: string;
  endDate: string;
  requestedAt: string;
};
export type ExportControllerRequestInvoiceExportClientIdPath = string;
export type RequestInvoiceExportBody = {
  companyId: string;
  startDate: string;
  endDate: string;
};
export type ExportControllerRetryInvoiceExportClientIdPath = string;
export type ExportControllerRetryInvoiceExportCompanyIdPath = string;
export type ExportControllerRetryInvoiceExportStartDatePath = string;
export type ExportControllerRetryInvoiceExportEndDatePath = string;
export type ExportControllerGetInvoiceExportsResponse = InvoiceExportRequestDTO[];
export type ExportControllerGetInvoiceExportsClientIdPath = string;
export type ExportControllerGetInvoiceExportClientIdPath = string;
export type ExportControllerGetInvoiceExportCompanyIdPath = string;
export type ExportControllerGetInvoiceExportStartDatePath = string;
export type ExportControllerGetInvoiceExportEndDatePath = string;
export type ExportControllerDownloadInvoiceExportResponse = string;
export type ExportControllerDownloadInvoiceExportClientIdPath = string;
export type ExportControllerDownloadInvoiceExportCompanyIdPath = string;
export type ExportControllerDownloadInvoiceExportStartDatePath = string;
export type ExportControllerDownloadInvoiceExportEndDatePath = string;
export type FineControllerListFinesResponse = FineDTO[];
export type FineDTO = FineData & { canBeUnpaid: boolean };
export type FineData = FineInitData & {
  isPaid: boolean;
  paymentOrigin?: FinePaymentOrigin;
  sendingDate?: string;
  remindDate?: string;
};
export type FineInitData = {
  id: string;
  contractId: string;
  clientId: string;
  rentalPeriodId: string;
  date: string;
  licensePlate: string;
};
export type FinePaymentOrigin = 'WEBAPP' | 'DASHBOARD';
export type FineControllerListFinesClientIdPath = string;
export type FineControllerListFinesRentalPeriodIdQuery = string;
export type FineControllerPayClientIdPath = string;
export type FineControllerPayRentalPeriodIdPath = string;
export type FineControllerPayFineIdPath = string;
export type FineControllerUnpayClientIdPath = string;
export type FineControllerUnpayRentalPeriodIdPath = string;
export type FineControllerUnpayFineIdPath = string;
export type FineControllerSendFineClientIdPath = string;
export type FineControllerSendFineRentalPeriodIdPath = string;
export type FineControllerSendFineFineIdPath = string;
export type FineControllerSendFineBody = { emails: string[]; htmlContent: string };
export type SafetyInspectionControllerSendToReviewClientIdPath = string;
export type SafetyInspectionControllerSendToReviewContractIdPath = string;
export type SafetyInspectionControllerSendToReviewRentalPeriodIdPath = string;
export type InspectionControllerGetIdPath = string;
export type CarToInsureControllerUploadInsuranceCertificateClientIdPath = string;
export type CarToInsureControllerUploadInsuranceCertificateContractIdPath = string;
export type CarToInsureControllerUploadInsuranceCertificateRentalPeriodIdPath = string;
export type CreateTicketRequest = {
  period?: { rentalPeriodId: string; contractId: string };
  ticket: { request: string; subject: string; category: TicketCategoryIds };
};
export enum TicketCategoryIds {
  bris_de_glace = 'bris_de_glace',
  defaut_mecanique_ou_electrique = 'defaut_mecanique_ou_electrique',
  pneumatiques_assistance = 'pneumatiques_assistance',
  carrosserie = 'carrosserie',
  accident = 'accident',
  panne = 'panne',

  maintenance_preventive = 'maintenance_preventive',
  maintenance_curative = 'maintenance_curative',
  pneumatiques_entretien = 'pneumatiques_entretien',
  controle_technique = 'controle_technique',

  outil_de_gestion_de_flotte = 'outil_de_gestion_de_flotte',
  changement_d_entite_du_contrat = 'changement_d_entite_du_contrat',
  contrat_de_location = 'contrat_de_location',
  taxe_sur_les_vehicules_de_societe_tvs = 'taxe_sur_les_vehicules_de_societe_tvs',
  facture = 'facture',

  souscription_ou_modification_de_contrat = 'souscription_ou_modification_de_contrat',
  question_sur_la_couverture = 'question_sur_la_couverture',
  releve_d_informations = 'releve_d_informations',
  memo_d_assurance = 'memo_d_assurance',

  avis_de_contravention = 'avis_de_contravention',
  forfait_post_stationnement_fps = 'forfait_post_stationnement_fps',
  amendes_europeennes = 'amendes_europeennes',
  peages = 'peages',
  carte_grise = 'carte_grise',
  vignette_critair = 'vignette_critair',
  utilisation_du_vehicule_a_l_etranger = 'utilisation_du_vehicule_a_l_etranger',

  suivi_de_livraison = 'suivi_de_livraison',
  restitution = 'restitution',

  autres_demandes = 'autres_demandes',
}
export type UserControllerAcceptCguClientIdPath = string;
export type UserControllerResendInvitationClientIdPath = string;
export type MandateConfigurationControllerGetMandateConfigurationLinkClientIdPath = string;
export type CarDocumentControllerExistsClientIdPath = string;
export type DashboardControllerListMediumTermCategoriesClientIdPath = string;
export type IntegrationControllerViewCarPictureClientIdPath = string;
export type IntegrationControllerDownloadImmatriculationClientIdPath = string;
export type IntegrationControllerDownloadInsuranceCertificateClientIdPath = string;
export type IntegrationControllerDownloadInspectionReportClientIdPath = string;
export type IntegrationControllerDownloadFinalInspectionReportClientIdPath = string;
export type IntegrationControllerDownloadAirStickerClientIdPath = string;
export type IntegrationControllerDownloadFivClientIdPath = string;
export type IntegrationControllerDownloadSafetyInspectionClientIdPath = string;
export type IntegrationControllerGetCarClientIdPath = string;
export type IntegrationControllerGetCarContractIdPath = string;
export type IntegrationControllerGetCarRentalPeriodIdPath = string;
export type IntegrationControllerGetContractClientIdPath = string;
export type IntegrationControllerGetContractContractIdPath = string;
export type IntegrationControllerListCarsToDeliverClientIdPath = string;
export type IntegrationControllerListInvoicesClientIdPath = string;
export type InspectionControllerGetClientIdPath = string;
export type TicketControllerCreateClientIdPath = string;